import { emailOTPClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import currentConfig from "@/config";

export const authClient = createAuthClient({
  baseURL: `${currentConfig.BASE_URL}/auth`,
  // basePath: "/auth",
  plugins: [emailOTPClient()],
});
